import { useState } from "react";

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqAccordion({ items }: { items: FaqItem[] }) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="space-y-3">
      {items.map((item, i) => (
        <div
          key={item.q}
          className={`rounded-lg border transition-colors ${
            open === i ? "border-primary-300 bg-primary-50" : "border-background-200 bg-background-50"
          }`}
        >
          <h3>
            <button
              type="button"
              onClick={() => setOpen(open === i ? null : i)}
              aria-expanded={open === i}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
            >
              <span className="font-heading font-semibold text-sm md:text-base text-foreground-950">
                {item.q}
              </span>
              <i
                className={`shrink-0 text-lg text-foreground-500 transition-transform ${
                  open === i ? "ri-subtract-line" : "ri-add-line"
                }`}
              />
            </button>
          </h3>
          {open === i && (
            <div className="px-5 pb-5 -mt-1">
              <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}